import React from 'react';

import '../icon-component.scss';

const UndoComponent = () => (
  <svg className="icon-component" viewBox="0 0 21 22">
    <g stroke="none" fill="none" fillRule="evenodd">
      <g transform="translate(-876.000000, -20.000000)" strokeWidth="2">
        <g transform="translate(481.000000, 0.000000)">
          <g transform="translate(397.000000, 21.000000)">
            <path d="M1,11.5 C1,16.1939838 4.80601622,20 9.5,20 C14.1939838,20 18,16.1939838 18,11.5 C18,6.80601622 14.1939838,3 9.5,3 L1,3" />
            <polyline points="2 0.5 0 2.99949566 2 5.5" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

UndoComponent.displayName = 'UndoIcon';

export default UndoComponent;
